export default __webpack_public_path__ + "static/media/dca-app.e627267d.jpeg";